<ng-container *ngIf="['item_view','loading'].includes(state)">
<div class="events-listing-container listing-full-size" style="position: relative">
  <div class="event-view-content class-view-content-first-row flex-justify-start"
       *ngIf="state === 'item_view'"
       style="position: absolute; top: -{{scrollTop}}px; left: 0px; z-index: 1;">
    <div class="flex-column-center">
      <div class="event-user-icon community-class-icon" style="position: relative">
        <img src="{{class['picture_src_preview']}}"
             alt="{{class['name']}}" title="{{class['name']}}"
        />
        <div class="hover-label-container ">
          <div class="hover-label">{{class['name']}}</div>
          <div *ngIf="config['type'] != 'cup'"
               class="hover-button-container flex-row-center flex-justify-start">

            <div *ngIf="!isClassOwner && !profileClassRelation"
                 [class.hover-button-active]="!hasRelationRequest"
                 (click)="pickClassForAction()"
                 class="hover-button hover-button-active flex-row-center flex-justify-start">
              <mat-icon style="margin-right: 4px;">add_task</mat-icon>
              <div *ngIf="config['type'] == 'user_class'">{{'join_class' | GetLabelPipe}}</div>
              <div *ngIf="['subscribe_event'].includes(config['type'])">{{'Subscribe!' | GetLabelPipe}}</div>
            </div>
            <div *ngIf="!isClassOwner && !profileClassRelation"
                 [class.hover-button-active]="!hasRelationRequest"
                 (click)="moreInfo()"
                 class="hover-button hover-button-active flex-row-center flex-justify-start">
              <mat-icon style="margin-right: 4px;">info</mat-icon>
              <div *ngIf="config['link']">{{'more' | GetLabelPipe}}</div>
            </div>
            <div *ngIf="!isClassOwner && profileClassRelation == 'pending'"
                 class="hover-button flex-row-center flex-justify-start">
              <mat-icon style="margin-right: 4px;">hourglass_top</mat-icon>
              <div>{{'wait_class_join_confirmation' | GetLabelPipe}}</div>
            </div>

            <ng-container *ngIf="isClassOwner || profileClassRelation == 'active'">
              <div (click)="toggleUsers()"
                   [class.hover-button-active]="listToggleState == 'users'"
                   class="hover-button flex-row-center flex-justify-start" matRipple>
                <mat-icon style="margin-right: 4px;">group</mat-icon>
                <div>{{'toggle_users_view' | GetLabelPipe}} ({{class['profiles'].length}})</div>
              </div>
              <div (click)="toggleActivity()"
                   [class.hover-button-active]="listToggleState == 'activity'"
                   class="hover-button flex-row-center flex-justify-start" matRipple>
                <mat-icon style="margin-right: 4px;">sports_handball</mat-icon>
                <div>{{'toggle_activity_view' | GetLabelPipe}}</div>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>

  <cdk-virtual-scroll-viewport *ngIf="state === 'item_view' && listToggleState === 'activity' && listing.listItems.length"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               (scroll)="onScroll($event)"
                               class="cdk-scroll">
    <div style="height: {{firstItemHeight}}px;">&nbsp;</div>
    <app-event-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                            [activeItemCounter]="listing.selectedListItems.length">
    </app-event-listing-item>
  </cdk-virtual-scroll-viewport>

  <cdk-virtual-scroll-viewport *ngIf="state === 'item_view' && listToggleState === 'users' && listing.listItems.length"
                               itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                               (scroll)="onScroll($event)"
                               class="cdk-scroll flex-column-center flex-justify-center">
    <div style="height: {{firstItemHeight}}px;">&nbsp;</div>
    <div *cdkVirtualFor="let listItem of listing.listItems;"
         class="flex-row-center flex-justify-center file-row-badge"
         matRipple [matRippleDisabled]="usersListRippleDisabled || listItem.itemFullData['id'] == application.user.id">
      <div class="file-row noselect" (click)="userClick($event,listItem)">
        <div matBadge="{{listItem.itemFullData.rank}}" matBadgeColor="accent">
          <img alt="" title="{{listItem.name}}. {{listItem.itemFullData.rank}} points."
               src="{{listItem.picture_ava}}" class="list-item-image"
               style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
          />
        </div>
        <div class="file-name noselect">
          {{listItem.name}}<br/>
          <div class="subrow flex-row-center" style="margin-top: 8px;">
            <div style="margin-right: 8px;">
              <mat-icon>sports_cricket</mat-icon>
            </div>
            <div>
<!--              <ng-container>Пн - Пт, ранок/день/вечір<br/></ng-container>-->
<!--              <ng-container>Сб - Нд, ранок/день/вечір<br/></ng-container>-->
              <ng-container *ngIf="!listItem.itemFullData['play_conf_weekdays_formatted'] && !listItem.itemFullData['play_conf_weekends_formatted']">{{'play_conf_not_set' | GetLabelPipe}}<br/></ng-container>
              <ng-container *ngIf="listItem.itemFullData['play_conf_weekdays_formatted']">{{'weekdays_range'|GetLabelPipe}}: {{listItem.itemFullData['play_conf_weekdays_formatted']}}<br/></ng-container>
              <ng-container *ngIf="listItem.itemFullData['play_conf_weekends_formatted']">{{'weekends_range'|GetLabelPipe}}: {{listItem.itemFullData['play_conf_weekends_formatted']}}<br/></ng-container>
            </div>
          </div>
        </div>
        <div class="file-menu" *ngIf="listItem.itemFullData['id'] != application.user.id">
          <button mat-icon-button [matMenuTriggerFor]="userGroupMenu"
                  (touchstart)="usersListRippleDisabled = true"
                  (touchend)="userMenuTouchEnd($event)"
                  (click)="userMenuClick($event)">
            <mat-icon>more_horiz</mat-icon>
          </button>
        </div>
      </div>
      <mat-menu #userGroupMenu="matMenu" class="file-menu">
        <ng-container *ngIf="isClassOwner || profileClassRelation == 'active'">
          <button mat-menu-item (click)="userClick($event, listItem)">
            <mat-icon>sports_cricket</mat-icon>
            {{'new_game' | GetLabelPipe}}
          </button>
          <hr>
          <button mat-menu-item (click)="sendUserMessage(listItem)">
            <mat-icon>message</mat-icon>
            {{'message' | GetLabelPipe}}
          </button>
          <hr>
          <button mat-menu-item (click)="getUserContact(listItem)">
            <mat-icon>contact_phone</mat-icon>
            {{'get_viber_contact' | GetLabelPipe}}
          </button>
          <hr>
        </ng-container>
        <button mat-menu-item (click)="showUserProfile(listItem)">
          <mat-icon>account_box</mat-icon>
          {{'player_profile' | GetLabelPipe}}
        </button>
      </mat-menu>
    </div>
  </cdk-virtual-scroll-viewport>

  <div *ngIf="state === 'item_view' && !listing.listItems.length">
    <div style="height: {{firstItemHeight}}px;">&nbsp;</div>
    <section class="empty-folder" fxLayout="column" fxLayoutAlign="center center"
             style="text-align: center;">
      <span *ngIf="true; else emptyAfterFilter">
        <mat-icon>event_busy</mat-icon>
        <p>No records found.</p>
      </span>
      <ng-template #emptyAfterFilter>
        <mat-icon>search</mat-icon>
        <p>No filter results.</p>
        <p class="secondary">Try another query</p>
      </ng-template>
    </section>
  </div>

  <div *ngIf="state === 'loading'" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
</div>
</ng-container>
<ng-container *ngIf="state === 'cup_players_view'">
  <app-simple-list [stateToPick]="'cup_players_view'"
                   [payload]="{class: class, players: players, games: games}"></app-simple-list>
</ng-container>
